import ru from './ru.json';

export default { ru };
